import { useContext } from 'react';

import { AdminExamRoomRequestInfoContext } from './admin-exam-room-request-info-provider';

function useAdminExamRoomRequestInfo() {
  const context = useContext(AdminExamRoomRequestInfoContext);

  if (!context) {
    throw new Error('useExamRoomRequestInfo must be used within a ExamRoomRequestInfoProvider');
  }

  return context;
}

export { useAdminExamRoomRequestInfo };
